export const retailers = [
  {
    "value": "24 Hour Fitness",
    "label": "24 Hour Fitness"
  },
  {
    "value": "7 Eleven",
    "label": "7 Eleven"
  },
  {
    "value": "99 Cents Only",
    "label": "99 Cents Only"
  },
  {
    "value": "99 Ranch Market",
    "label": "99 Ranch Market"
  },
  {
    "value": "ABC Stores",
    "label": "ABC Stores"
  },
  {
    "value": "ABC Wine & Spirits",
    "label": "ABC Wine & Spirits"
  },
  {
    "value": "Academy",
    "label": "Academy"
  },
  {
    "value": "Ace Hardware",
    "label": "Ace Hardware"
  },
  {
    "value": "Acme Markets ",
    "label": "Acme Markets "
  },
  {
    "value": "A.C. Moore Arts & Crafts",
    "label": "A.C. Moore Arts & Crafts"
  },
  {
    "value": "Addition Elle",
    "label": "Addition Elle"
  },
  {
    "value": "Adore Me",
    "label": "Adore Me"
  },
  {
    "value": "Advance Auto Parts ",
    "label": "Advance Auto Parts "
  },
  {
    "value": "Aerie",
    "label": "Aerie"
  },
  {
    "value": "AGFL",
    "label": "AGFL"
  },
  {
    "value": "Ahold USA/Royal Ahold",
    "label": "Ahold USA/Royal Ahold"
  },
  {
    "value": "AJ’s Fine Foods",
    "label": "AJ’s Fine Foods"
  },
  {
    "value": "Akin's Natural Foods",
    "label": "Akin's Natural Foods"
  },
  {
    "value": "Albertsons",
    "label": "Albertsons"
  },
  {
    "value": "Albertsons.com",
    "label": "Albertsons.com"
  },
  {
    "value": "Albertsons Marketplace",
    "label": "Albertsons Marketplace"
  },
  {
    "value": "Aldi",
    "label": "Aldi"
  },
  {
    "value": "A Matter of Health",
    "label": "A Matter of Health"
  },
  {
    "value": "Amazon",
    "label": "Amazon"
  },
  {
    "value": "Amazon AU",
    "label": "Amazon AU"
  },
  {
    "value": "Amazon.ca",
    "label": "Amazon.ca"
  },
  {
    "value": "American Eagle",
    "label": "American Eagle"
  },
  {
    "value": "American Museum of Natural History",
    "label": "American Museum of Natural History"
  },
  {
    "value": "ampm",
    "label": "ampm"
  },
  {
    "value": "A Natural Pet Pantry",
    "label": "A Natural Pet Pantry"
  },
  {
    "value": "Andronico's",
    "label": "Andronico's"
  },
  {
    "value": "Ann's Health Food Market",
    "label": "Ann's Health Food Market"
  },
  {
    "value": "Anthropologie",
    "label": "Anthropologie"
  },
  {
    "value": "Apple Stores",
    "label": "Apple Stores"
  },
  {
    "value": "Army Air Force Exchange",
    "label": "Army Air Force Exchange"
  },
  {
    "value": "ASDA",
    "label": "ASDA"
  },
  {
    "value": "As Nature Intended",
    "label": "As Nature Intended"
  },
  {
    "value": "AS Watson Group",
    "label": "AS Watson Group"
  },
  {
    "value": "AT&T Wireless",
    "label": "AT&T Wireless"
  },
  {
    "value": "Auggie's Pet Supplies",
    "label": "Auggie's Pet Supplies"
  },
  {
    "value": "Autozone",
    "label": "Autozone"
  },
  {
    "value": "Barnes & Noble",
    "label": "Barnes & Noble"
  },
  {
    "value": "Bartell Drug",
    "label": "Bartell Drug"
  },
  {
    "value": "Bass Pro",
    "label": "Bass Pro"
  },
  {
    "value": "Bath & Body Works",
    "label": "Bath & Body Works"
  },
  {
    "value": "Bealls",
    "label": "Bealls"
  },
  {
    "value": "Beauty 4 U",
    "label": "Beauty 4 U"
  },
  {
    "value": "Beauty Bridge",
    "label": "Beauty Bridge"
  },
  {
    "value": "BeautyCareChoices.com",
    "label": "BeautyCareChoices.com"
  },
  {
    "value": "Beauty Collection",
    "label": "Beauty Collection"
  },
  {
    "value": "Bedbathandbeyond.com",
    "label": "Bedbathandbeyond.com"
  },
  {
    "value": "Bed Bath & Beyond",
    "label": "Bed Bath & Beyond"
  },
  {
    "value": "Belk",
    "label": "Belk"
  },
  {
    "value": "Best Buy",
    "label": "Best Buy"
  },
  {
    "value": "BestBuy.com",
    "label": "BestBuy.com"
  },
  {
    "value": "BevMo! ",
    "label": "BevMo! "
  },
  {
    "value": "Big 5 Sporting Goods",
    "label": "Big 5 Sporting Goods"
  },
  {
    "value": "Big Lots",
    "label": "Big Lots"
  },
  {
    "value": "Big Saver Foods",
    "label": "Big Saver Foods"
  },
  {
    "value": "Big W",
    "label": "Big W"
  },
  {
    "value": "Big Y",
    "label": "Big Y"
  },
  {
    "value": "Bi-Lo",
    "label": "Bi-Lo"
  },
  {
    "value": "Bi-Mart",
    "label": "Bi-Mart"
  },
  {
    "value": "Binny's Beverage Depot",
    "label": "Binny's Beverage Depot"
  },
  {
    "value": "Birchbox",
    "label": "Birchbox"
  },
  {
    "value": "Bi-Rite",
    "label": "Bi-Rite"
  },
  {
    "value": "BJ's Wholesale Club",
    "label": "BJ's Wholesale Club"
  },
  {
    "value": "Bloomingdale's",
    "label": "Bloomingdale's"
  },
  {
    "value": "Blue Mercury",
    "label": "Blue Mercury"
  },
  {
    "value": "Blush Lane Organic Market",
    "label": "Blush Lane Organic Market"
  },
  {
    "value": "Bodybuilding.com",
    "label": "Bodybuilding.com"
  },
  {
    "value": "Bon-Ton",
    "label": "Bon-Ton"
  },
  {
    "value": "Books a Million",
    "label": "Books a Million"
  },
  {
    "value": "Boots",
    "label": "Boots"
  },
  {
    "value": "Boscov’s",
    "label": "Boscov’s"
  },
  {
    "value": "Boutsy",
    "label": "Boutsy"
  },
  {
    "value": "Box Lunch",
    "label": "Box Lunch"
  },
  {
    "value": "Bristol Farms",
    "label": "Bristol Farms"
  },
  {
    "value": "Brookshire's",
    "label": "Brookshire's"
  },
  {
    "value": "Brookstone",
    "label": "Brookstone"
  },
  {
    "value": "Buehler's Fresh Foods",
    "label": "Buehler's Fresh Foods"
  },
  {
    "value": "Bunnings Warehouse ",
    "label": "Bunnings Warehouse "
  },
  {
    "value": "Burlington Coat Factory",
    "label": "Burlington Coat Factory"
  },
  {
    "value": "Busch's Fresh Food Market",
    "label": "Busch's Fresh Food Market"
  },
  {
    "value": "Buy Buy Baby",
    "label": "Buy Buy Baby"
  },
  {
    "value": "BuyBuy Baby",
    "label": "BuyBuy Baby"
  },
  {
    "value": "Buybuybaby.com",
    "label": "Buybuybaby.com"
  },
  {
    "value": "Buy-Rite Drugs",
    "label": "Buy-Rite Drugs"
  },
  {
    "value": "Cabela's",
    "label": "Cabela's"
  },
  {
    "value": "CAL Ranch Stores",
    "label": "CAL Ranch Stores"
  },
  {
    "value": "Calufe Coffee",
    "label": "Calufe Coffee"
  },
  {
    "value": "Camping World",
    "label": "Camping World"
  },
  {
    "value": "Canadian Tire Corporation",
    "label": "Canadian Tire Corporation"
  },
  {
    "value": "Canyon Ranch",
    "label": "Canyon Ranch"
  },
  {
    "value": "Cardinal Health RGH",
    "label": "Cardinal Health RGH"
  },
  {
    "value": "Care Pharmacies Cooperative",
    "label": "Care Pharmacies Cooperative"
  },
  {
    "value": "CARiD",
    "label": "CARiD"
  },
  {
    "value": "Casey's General Stores",
    "label": "Casey's General Stores"
  },
  {
    "value": "Central Market ",
    "label": "Central Market "
  },
  {
    "value": "Centro Natural",
    "label": "Centro Natural"
  },
  {
    "value": "Cermak Fresh Market",
    "label": "Cermak Fresh Market"
  },
  {
    "value": "Chamberlain’s Market",
    "label": "Chamberlain’s Market"
  },
  {
    "value": "Chamberlin's Natural Food Market ",
    "label": "Chamberlin's Natural Food Market "
  },
  {
    "value": "Charlotte Russe",
    "label": "Charlotte Russe"
  },
  {
    "value": "Charming Charlie",
    "label": "Charming Charlie"
  },
  {
    "value": "Checkers",
    "label": "Checkers"
  },
  {
    "value": "Cherry Valley Marketplace",
    "label": "Cherry Valley Marketplace"
  },
  {
    "value": "Chevron",
    "label": "Chevron"
  },
  {
    "value": "Chewy.com",
    "label": "Chewy.com"
  },
  {
    "value": "Christmas Tree Shops",
    "label": "Christmas Tree Shops"
  },
  {
    "value": "Christmas Tree Shops ",
    "label": "Christmas Tree Shops "
  },
  {
    "value": "Cibo Express",
    "label": "Cibo Express"
  },
  {
    "value": "Cibo Market",
    "label": "Cibo Market"
  },
  {
    "value": "Circle K",
    "label": "Circle K"
  },
  {
    "value": "Citi Trends",
    "label": "Citi Trends"
  },
  {
    "value": "City Fresh Market",
    "label": "City Fresh Market"
  },
  {
    "value": "Claire's",
    "label": "Claire's"
  },
  {
    "value": "Clas Ohlson",
    "label": "Clas Ohlson"
  },
  {
    "value": "Clean Beauty Mart",
    "label": "Clean Beauty Mart"
  },
  {
    "value": "Coast Guard Exchange",
    "label": "Coast Guard Exchange"
  },
  {
    "value": "C.O. Bigelow",
    "label": "C.O. Bigelow"
  },
  {
    "value": "Coborn's",
    "label": "Coborn's"
  },
  {
    "value": "Coffee Bean",
    "label": "Coffee Bean"
  },
  {
    "value": "Coles",
    "label": "Coles"
  },
  {
    "value": "Complete Nutrition",
    "label": "Complete Nutrition"
  },
  {
    "value": "CosmoProf",
    "label": "CosmoProf"
  },
  {
    "value": "Costco",
    "label": "Costco"
  },
  {
    "value": "Costco.ca",
    "label": "Costco.ca"
  },
  {
    "value": "Costco.com",
    "label": "Costco.com"
  },
  {
    "value": "Cost Plus World Market",
    "label": "Cost Plus World Market"
  },
  {
    "value": "Country Grocers",
    "label": "Country Grocers"
  },
  {
    "value": "Cracker Barrel Old Country Stores",
    "label": "Cracker Barrel Old Country Stores"
  },
  {
    "value": "Credo",
    "label": "Credo"
  },
  {
    "value": "Crest Fresh Market",
    "label": "Crest Fresh Market"
  },
  {
    "value": "Crosby's Marketplace",
    "label": "Crosby's Marketplace"
  },
  {
    "value": "Cub Foods",
    "label": "Cub Foods"
  },
  {
    "value": "CVS",
    "label": "CVS"
  },
  {
    "value": "Daiso",
    "label": "Daiso"
  },
  {
    "value": "Dash In ",
    "label": "Dash In "
  },
  {
    "value": "Dean & Deluca",
    "label": "Dean & Deluca"
  },
  {
    "value": "Debenhams",
    "label": "Debenhams"
  },
  {
    "value": "Delhaize America",
    "label": "Delhaize America"
  },
  {
    "value": "Delta Airlines",
    "label": "Delta Airlines"
  },
  {
    "value": "Demoulas Super Markets",
    "label": "Demoulas Super Markets"
  },
  {
    "value": "dermstore.com",
    "label": "dermstore.com"
  },
  {
    "value": "Dick's Sporting Goods",
    "label": "Dick's Sporting Goods"
  },
  {
    "value": "DicksSportingGoods.com",
    "label": "DicksSportingGoods.com"
  },
  {
    "value": "Dierbergs",
    "label": "Dierbergs"
  },
  {
    "value": "Dillard's",
    "label": "Dillard's"
  },
  {
    "value": "Dillons",
    "label": "Dillons"
  },
  {
    "value": "Discount Drug Mart",
    "label": "Discount Drug Mart"
  },
  {
    "value": "Dixons Retail",
    "label": "Dixons Retail"
  },
  {
    "value": "Do It Best",
    "label": "Do It Best"
  },
  {
    "value": "Dollar General",
    "label": "Dollar General"
  },
  {
    "value": "Dollar General ",
    "label": "Dollar General "
  },
  {
    "value": "Dollar Tree",
    "label": "Dollar Tree"
  },
  {
    "value": "Dorothy Lane",
    "label": "Dorothy Lane"
  },
  {
    "value": "Draeger's Market",
    "label": "Draeger's Market"
  },
  {
    "value": "Duluth Trading",
    "label": "Duluth Trading"
  },
  {
    "value": "Dylan's Candy Bar",
    "label": "Dylan's Candy Bar"
  },
  {
    "value": "Earthbound Trading Co. ",
    "label": "Earthbound Trading Co. "
  },
  {
    "value": "Earth Fair",
    "label": "Earth Fair"
  },
  {
    "value": "Earth Origins Market",
    "label": "Earth Origins Market"
  },
  {
    "value": "Ebay",
    "label": "Ebay"
  },
  {
    "value": "El Cortes Ingles",
    "label": "El Cortes Ingles"
  },
  {
    "value": "Elegant Beauty Supplies",
    "label": "Elegant Beauty Supplies"
  },
  {
    "value": "El Super",
    "label": "El Super"
  },
  {
    "value": "En Market",
    "label": "En Market"
  },
  {
    "value": "Erewhon Natural Foods",
    "label": "Erewhon Natural Foods"
  },
  {
    "value": "Etsy.com",
    "label": "Etsy.com"
  },
  {
    "value": "Evine Live",
    "label": "Evine Live"
  },
  {
    "value": "FabFitFun",
    "label": "FabFitFun"
  },
  {
    "value": "Faire",
    "label": "Faire"
  },
  {
    "value": "Fairway Market",
    "label": "Fairway Market"
  },
  {
    "value": "Fam Coop",
    "label": "Fam Coop"
  },
  {
    "value": "Familiprix",
    "label": "Familiprix"
  },
  {
    "value": "Family Dollar Stores",
    "label": "Family Dollar Stores"
  },
  {
    "value": "Family Foods",
    "label": "Family Foods"
  },
  {
    "value": "Fareway Stores",
    "label": "Fareway Stores"
  },
  {
    "value": "FedEx Office Print & Ship Center",
    "label": "FedEx Office Print & Ship Center"
  },
  {
    "value": "Feel Beauty Supply",
    "label": "Feel Beauty Supply"
  },
  {
    "value": "Feelunique",
    "label": "Feelunique"
  },
  {
    "value": "Fenwick",
    "label": "Fenwick"
  },
  {
    "value": "Festival Foods",
    "label": "Festival Foods"
  },
  {
    "value": "Fiesta Mart",
    "label": "Fiesta Mart"
  },
  {
    "value": "Fine Wine & Good Spirits",
    "label": "Fine Wine & Good Spirits"
  },
  {
    "value": "Fit2Run",
    "label": "Fit2Run"
  },
  {
    "value": "Five Star Food Mart",
    "label": "Five Star Food Mart"
  },
  {
    "value": "Follow Your Heart",
    "label": "Follow Your Heart"
  },
  {
    "value": "Food4Less",
    "label": "Food4Less"
  },
  {
    "value": "Foodland",
    "label": "Foodland"
  },
  {
    "value": "Food Lion",
    "label": "Food Lion"
  },
  {
    "value": "FoodMaxx",
    "label": "FoodMaxx"
  },
  {
    "value": "Foodtown",
    "label": "Foodtown"
  },
  {
    "value": "Foot Locker",
    "label": "Foot Locker"
  },
  {
    "value": "Forever 21",
    "label": "Forever 21"
  },
  {
    "value": "Fortnum and Mason",
    "label": "Fortnum and Mason"
  },
  {
    "value": "Four Seasons Hotels and Resorts",
    "label": "Four Seasons Hotels and Resorts"
  },
  {
    "value": "Francesca's",
    "label": "Francesca's"
  },
  {
    "value": "Fred Meyer",
    "label": "Fred Meyer"
  },
  {
    "value": "Fred's Pharmacy",
    "label": "Fred's Pharmacy"
  },
  {
    "value": "Free People",
    "label": "Free People"
  },
  {
    "value": "Freshmart",
    "label": "Freshmart"
  },
  {
    "value": "Fresh Thyme Market",
    "label": "Fresh Thyme Market"
  },
  {
    "value": "Fressnapf",
    "label": "Fressnapf"
  },
  {
    "value": "Fruth Pharmacy",
    "label": "Fruth Pharmacy"
  },
  {
    "value": "Fry's",
    "label": "Fry's"
  },
  {
    "value": "Fuego",
    "label": "Fuego"
  },
  {
    "value": "F.Y.E",
    "label": "F.Y.E"
  },
  {
    "value": "Gala Fresh Farms",
    "label": "Gala Fresh Farms"
  },
  {
    "value": "Game",
    "label": "Game"
  },
  {
    "value": "GameStop",
    "label": "GameStop"
  },
  {
    "value": "Gander Mountain",
    "label": "Gander Mountain"
  },
  {
    "value": "Gateway Newstands",
    "label": "Gateway Newstands"
  },
  {
    "value": "Gelson's",
    "label": "Gelson's"
  },
  {
    "value": "Gelson's Markets",
    "label": "Gelson's Markets"
  },
  {
    "value": "Genesco",
    "label": "Genesco"
  },
  {
    "value": "Get-Go",
    "label": "Get-Go"
  },
  {
    "value": "Giant Eagle",
    "label": "Giant Eagle"
  },
  {
    "value": "Giant Food",
    "label": "Giant Food"
  },
  {
    "value": "G&M",
    "label": "G&M"
  },
  {
    "value": "GNC",
    "label": "GNC"
  },
  {
    "value": "Good 2 Go",
    "label": "Good 2 Go"
  },
  {
    "value": "Good Neighbor Pharmacy",
    "label": "Good Neighbor Pharmacy"
  },
  {
    "value": "Goody Goody Liquors",
    "label": "Goody Goody Liquors"
  },
  {
    "value": "Gordmans",
    "label": "Gordmans"
  },
  {
    "value": "Grainger Games",
    "label": "Grainger Games"
  },
  {
    "value": "Green Acres Market",
    "label": "Green Acres Market"
  },
  {
    "value": "Gristedes",
    "label": "Gristedes"
  },
  {
    "value": "Grocery Outlet",
    "label": "Grocery Outlet"
  },
  {
    "value": "GrubMarket",
    "label": "GrubMarket"
  },
  {
    "value": "Haggen",
    "label": "Haggen"
  },
  {
    "value": "Hallmark",
    "label": "Hallmark"
  },
  {
    "value": "Hammacher Schlemmer ",
    "label": "Hammacher Schlemmer "
  },
  {
    "value": "Hannaford",
    "label": "Hannaford"
  },
  {
    "value": "Harmon Discount",
    "label": "Harmon Discount"
  },
  {
    "value": "Harmons Grocery",
    "label": "Harmons Grocery"
  },
  {
    "value": "Harp's Food Stores",
    "label": "Harp's Food Stores"
  },
  {
    "value": "Harris Teeter",
    "label": "Harris Teeter"
  },
  {
    "value": "Harris-Teeter",
    "label": "Harris-Teeter"
  },
  {
    "value": "Harry & David",
    "label": "Harry & David"
  },
  {
    "value": "Harvest Foods",
    "label": "Harvest Foods"
  },
  {
    "value": "Harvey Nichols",
    "label": "Harvey Nichols"
  },
  {
    "value": "HayNeedle.com",
    "label": "HayNeedle.com"
  },
  {
    "value": "HB Beauty Bar",
    "label": "HB Beauty Bar"
  },
  {
    "value": "Health Mart",
    "label": "Health Mart"
  },
  {
    "value": "HEB",
    "label": "HEB"
  },
  {
    "value": "HEB Grocery",
    "label": "HEB Grocery"
  },
  {
    "value": "Heinen's",
    "label": "Heinen's"
  },
  {
    "value": "Hello Fresh",
    "label": "Hello Fresh"
  },
  {
    "value": "Hera Beauty",
    "label": "Hera Beauty"
  },
  {
    "value": "Herberger's",
    "label": "Herberger's"
  },
  {
    "value": "Herrington Catalog",
    "label": "Herrington Catalog"
  },
  {
    "value": "Hibbett Sports",
    "label": "Hibbett Sports"
  },
  {
    "value": "Hilton Hotels",
    "label": "Hilton Hotels"
  },
  {
    "value": "H Mart ",
    "label": "H Mart "
  },
  {
    "value": "HMS Host",
    "label": "HMS Host"
  },
  {
    "value": "Hobby Lobby",
    "label": "Hobby Lobby"
  },
  {
    "value": "HobbyTown ",
    "label": "HobbyTown "
  },
  {
    "value": "Holland and Barrett",
    "label": "Holland and Barrett"
  },
  {
    "value": "homedepot.com",
    "label": "homedepot.com"
  },
  {
    "value": "HomeGoods",
    "label": "HomeGoods"
  },
  {
    "value": "Home Hardware",
    "label": "Home Hardware"
  },
  {
    "value": "Home Hardware Stores Limited",
    "label": "Home Hardware Stores Limited"
  },
  {
    "value": "Homeland",
    "label": "Homeland"
  },
  {
    "value": "HomeSense",
    "label": "HomeSense"
  },
  {
    "value": "Hot Topic",
    "label": "Hot Topic"
  },
  {
    "value": "HSN",
    "label": "HSN"
  },
  {
    "value": "Huckleberry's Natural Market",
    "label": "Huckleberry's Natural Market"
  },
  {
    "value": "Hucks Convenience Store",
    "label": "Hucks Convenience Store"
  },
  {
    "value": "Hudson's Bay Company",
    "label": "Hudson's Bay Company"
  },
  {
    "value": "Hush",
    "label": "Hush"
  },
  {
    "value": "Hy-Vee",
    "label": "Hy-Vee"
  },
  {
    "value": "Icing",
    "label": "Icing"
  },
  {
    "value": "IDA Pharmacy",
    "label": "IDA Pharmacy"
  },
  {
    "value": "IFA Country Stores ",
    "label": "IFA Country Stores "
  },
  {
    "value": "IGA",
    "label": "IGA"
  },
  {
    "value": "IGA Grocers ",
    "label": "IGA Grocers "
  },
  {
    "value": "iHerb",
    "label": "iHerb"
  },
  {
    "value": "Ikea",
    "label": "Ikea"
  },
  {
    "value": "Independent Convenience",
    "label": "Independent Convenience"
  },
  {
    "value": "Independent Grocery",
    "label": "Independent Grocery"
  },
  {
    "value": "Independent Gym",
    "label": "Independent Gym"
  },
  {
    "value": "Independent Optical Stores",
    "label": "Independent Optical Stores"
  },
  {
    "value": "Independent Pharmacy",
    "label": "Independent Pharmacy"
  },
  {
    "value": "Independent Restaurant ",
    "label": "Independent Restaurant "
  },
  {
    "value": "Independent Retailers",
    "label": "Independent Retailers"
  },
  {
    "value": "Indigo",
    "label": "Indigo"
  },
  {
    "value": "Ingles Market",
    "label": "Ingles Market"
  },
  {
    "value": "Inter Natural",
    "label": "Inter Natural"
  },
  {
    "value": "Ipsy",
    "label": "Ipsy"
  },
  {
    "value": "ISO 13485:2016",
    "label": "ISO 13485:2016"
  },
  {
    "value": "It's Sugar",
    "label": "It's Sugar"
  },
  {
    "value": "Jacksons Food Stores",
    "label": "Jacksons Food Stores"
  },
  {
    "value": "Jane",
    "label": "Jane"
  },
  {
    "value": "J.C. Penney",
    "label": "J.C. Penney"
  },
  {
    "value": "J. Crew",
    "label": "J. Crew"
  },
  {
    "value": "Jean Coutu",
    "label": "Jean Coutu"
  },
  {
    "value": "Jensen's Finest Foods",
    "label": "Jensen's Finest Foods"
  },
  {
    "value": "Jet",
    "label": "Jet"
  },
  {
    "value": "JetBlue Airlines",
    "label": "JetBlue Airlines"
  },
  {
    "value": "Jewel-Osco",
    "label": "Jewel-Osco"
  },
  {
    "value": "Jimbo's ",
    "label": "Jimbo's "
  },
  {
    "value": "Jimbo's Natural Foods Grocer",
    "label": "Jimbo's Natural Foods Grocer"
  },
  {
    "value": "Jo-Ann Fabric and Craft",
    "label": "Jo-Ann Fabric and Craft"
  },
  {
    "value": "Jons Marketplace ",
    "label": "Jons Marketplace "
  },
  {
    "value": "Key Foods",
    "label": "Key Foods"
  },
  {
    "value": "Kid to Kid",
    "label": "Kid to Kid"
  },
  {
    "value": "King Kullen",
    "label": "King Kullen"
  },
  {
    "value": "Kings Food Markets",
    "label": "Kings Food Markets"
  },
  {
    "value": "King Soopers",
    "label": "King Soopers"
  },
  {
    "value": "Kinney Drugs",
    "label": "Kinney Drugs"
  },
  {
    "value": "Kirkland's",
    "label": "Kirkland's"
  },
  {
    "value": "Kitchen Collection ",
    "label": "Kitchen Collection "
  },
  {
    "value": "Kohl's",
    "label": "Kohl's"
  },
  {
    "value": "Kotsovolos",
    "label": "Kotsovolos"
  },
  {
    "value": "Kowalski's",
    "label": "Kowalski's"
  },
  {
    "value": "Kroger",
    "label": "Kroger"
  },
  {
    "value": "Kwik Trip ",
    "label": "Kwik Trip "
  },
  {
    "value": "Lassens",
    "label": "Lassens"
  },
  {
    "value": "Lawtons",
    "label": "Lawtons"
  },
  {
    "value": "Lazy Acres",
    "label": "Lazy Acres"
  },
  {
    "value": "Lee Valley Tools ",
    "label": "Lee Valley Tools "
  },
  {
    "value": "Lewis Drug, Inc.",
    "label": "Lewis Drug, Inc."
  },
  {
    "value": "Lidl",
    "label": "Lidl"
  },
  {
    "value": "Lifetime",
    "label": "Lifetime"
  },
  {
    "value": "L.L. Bean",
    "label": "L.L. Bean"
  },
  {
    "value": "Loblaws",
    "label": "Loblaws"
  },
  {
    "value": "Lolli and Pops",
    "label": "Lolli and Pops"
  },
  {
    "value": "London Drugs",
    "label": "London Drugs"
  },
  {
    "value": "Lord & Taylor",
    "label": "Lord & Taylor"
  },
  {
    "value": "Lou & Grey",
    "label": "Lou & Grey"
  },
  {
    "value": "Lowe's ",
    "label": "Lowe's "
  },
  {
    "value": "Lowes.com",
    "label": "Lowes.com"
  },
  {
    "value": "Lowes Foods",
    "label": "Lowes Foods"
  },
  {
    "value": "Lucky's Market",
    "label": "Lucky's Market"
  },
  {
    "value": "Lucky Supermarkets ",
    "label": "Lucky Supermarkets "
  },
  {
    "value": "Lucky Vitamin",
    "label": "Lucky Vitamin"
  },
  {
    "value": "Luckyvitamin.com",
    "label": "Luckyvitamin.com"
  },
  {
    "value": "Lunardi's Markets",
    "label": "Lunardi's Markets"
  },
  {
    "value": "Lund's & Byerlys",
    "label": "Lund's & Byerlys"
  },
  {
    "value": "Lunds & Byerly's",
    "label": "Lunds & Byerly's"
  },
  {
    "value": "Maceys ",
    "label": "Maceys "
  },
  {
    "value": "Mac's Fresh Market",
    "label": "Mac's Fresh Market"
  },
  {
    "value": "Macy's ",
    "label": "Macy's "
  },
  {
    "value": "Macy's Backstage",
    "label": "Macy's Backstage"
  },
  {
    "value": "Macys.com",
    "label": "Macys.com"
  },
  {
    "value": "Maison Baby",
    "label": "Maison Baby"
  },
  {
    "value": "Makro",
    "label": "Makro"
  },
  {
    "value": "Marathon",
    "label": "Marathon"
  },
  {
    "value": "Marc’s Store & Grocery",
    "label": "Marc’s Store & Grocery"
  },
  {
    "value": "Mariano's",
    "label": "Mariano's"
  },
  {
    "value": "Mariano’s",
    "label": "Mariano’s"
  },
  {
    "value": "Marine Corps Exchange",
    "label": "Marine Corps Exchange"
  },
  {
    "value": "Market Basket",
    "label": "Market Basket"
  },
  {
    "value": "Market District",
    "label": "Market District"
  },
  {
    "value": "Market Street",
    "label": "Market Street"
  },
  {
    "value": "Marks & Spencer ",
    "label": "Marks & Spencer "
  },
  {
    "value": "Marlene's Market & Deli",
    "label": "Marlene's Market & Deli"
  },
  {
    "value": "Marriott Hotels & Resorts",
    "label": "Marriott Hotels & Resorts"
  },
  {
    "value": "Marshalls ",
    "label": "Marshalls "
  },
  {
    "value": "Marsh Supermarkets",
    "label": "Marsh Supermarkets"
  },
  {
    "value": "Martin's Super Markets",
    "label": "Martin's Super Markets"
  },
  {
    "value": "Mar-val Food Stores",
    "label": "Mar-val Food Stores"
  },
  {
    "value": "Maverik Inc. ",
    "label": "Maverik Inc. "
  },
  {
    "value": "Max Muscle Nutrition",
    "label": "Max Muscle Nutrition"
  },
  {
    "value": "McKesson",
    "label": "McKesson"
  },
  {
    "value": "Medicine Shoppe International",
    "label": "Medicine Shoppe International"
  },
  {
    "value": "Meijer",
    "label": "Meijer"
  },
  {
    "value": "Menards",
    "label": "Menards"
  },
  {
    "value": "Metro",
    "label": "Metro"
  },
  {
    "value": "Michaels",
    "label": "Michaels"
  },
  {
    "value": "Military Deli and Bakery Services",
    "label": "Military Deli and Bakery Services"
  },
  {
    "value": "Mills Fleet Farm",
    "label": "Mills Fleet Farm"
  },
  {
    "value": "Ministop",
    "label": "Ministop"
  },
  {
    "value": "Miraval",
    "label": "Miraval"
  },
  {
    "value": "Modell's Sporting Goods",
    "label": "Modell's Sporting Goods"
  },
  {
    "value": "Mollie Stones",
    "label": "Mollie Stones"
  },
  {
    "value": "Mom's Organic Market",
    "label": "Mom's Organic Market"
  },
  {
    "value": "MOM's Organic Market ",
    "label": "MOM's Organic Market "
  },
  {
    "value": "Morton Williams",
    "label": "Morton Williams"
  },
  {
    "value": "Mother's Market",
    "label": "Mother's Market"
  },
  {
    "value": "NAPA Auto Parts",
    "label": "NAPA Auto Parts"
  },
  {
    "value": "National Co+op Grocers",
    "label": "National Co+op Grocers"
  },
  {
    "value": "National Park Service",
    "label": "National Park Service"
  },
  {
    "value": "Natural Frontier Market",
    "label": "Natural Frontier Market"
  },
  {
    "value": "Natural Grocers ",
    "label": "Natural Grocers "
  },
  {
    "value": "Nature's Fare",
    "label": "Nature's Fare"
  },
  {
    "value": "Neiman Marcus",
    "label": "Neiman Marcus"
  },
  {
    "value": "Newegg.com",
    "label": "Newegg.com"
  },
  {
    "value": " New Leaf Community Markets",
    "label": " New Leaf Community Markets"
  },
  {
    "value": "New Season's Market",
    "label": "New Season's Market"
  },
  {
    "value": "NEX Navy Exchange",
    "label": "NEX Navy Exchange"
  },
  {
    "value": "Next",
    "label": "Next"
  },
  {
    "value": "Nordstrom",
    "label": "Nordstrom"
  },
  {
    "value": "Nugget Market",
    "label": "Nugget Market"
  },
  {
    "value": "Nugget Markets",
    "label": "Nugget Markets"
  },
  {
    "value": "Nutrishop",
    "label": "Nutrishop"
  },
  {
    "value": "Nutrition Smart",
    "label": "Nutrition Smart"
  },
  {
    "value": "Nutters",
    "label": "Nutters"
  },
  {
    "value": "Ocean State Job Lot",
    "label": "Ocean State Job Lot"
  },
  {
    "value": "Office Depot",
    "label": "Office Depot"
  },
  {
    "value": "OfficeDepot.com",
    "label": "OfficeDepot.com"
  },
  {
    "value": "OfficeMax",
    "label": "OfficeMax"
  },
  {
    "value": "Oil & Vinegar",
    "label": "Oil & Vinegar"
  },
  {
    "value": "Once Upon a Child",
    "label": "Once Upon a Child"
  },
  {
    "value": "One Dollar Zone",
    "label": "One Dollar Zone"
  },
  {
    "value": "One Step Ahead ",
    "label": "One Step Ahead "
  },
  {
    "value": "Orchard Supply Hardware",
    "label": "Orchard Supply Hardware"
  },
  {
    "value": "O'Reilly Auto",
    "label": "O'Reilly Auto"
  },
  {
    "value": "OTG",
    "label": "OTG"
  },
  {
    "value": "OU Kosher ",
    "label": "OU Kosher "
  },
  {
    "value": "Overstock.com",
    "label": "Overstock.com"
  },
  {
    "value": "Overwaitea Foods",
    "label": "Overwaitea Foods"
  },
  {
    "value": "Pacific Health Foods",
    "label": "Pacific Health Foods"
  },
  {
    "value": "Paper Source ",
    "label": "Paper Source "
  },
  {
    "value": "Party City",
    "label": "Party City"
  },
  {
    "value": "Patel Brothers",
    "label": "Patel Brothers"
  },
  {
    "value": "Pavilions",
    "label": "Pavilions"
  },
  {
    "value": "PCC Natural Markets",
    "label": "PCC Natural Markets"
  },
  {
    "value": "Peninsula Beauty",
    "label": "Peninsula Beauty"
  },
  {
    "value": "Pep Boys",
    "label": "Pep Boys"
  },
  {
    "value": "Petco",
    "label": "Petco"
  },
  {
    "value": "Pete's Fresh Market",
    "label": "Pete's Fresh Market"
  },
  {
    "value": "Petsmart",
    "label": "Petsmart"
  },
  {
    "value": "Pet Supermarket ",
    "label": "Pet Supermarket "
  },
  {
    "value": "Pet Supplies Plus",
    "label": "Pet Supplies Plus"
  },
  {
    "value": "Pet Valu",
    "label": "Pet Valu"
  },
  {
    "value": "Pharmaca",
    "label": "Pharmaca"
  },
  {
    "value": "PharmaChoice",
    "label": "PharmaChoice"
  },
  {
    "value": "Pharmaprix",
    "label": "Pharmaprix"
  },
  {
    "value": "Pharmasave",
    "label": "Pharmasave"
  },
  {
    "value": "Pick n Pay",
    "label": "Pick n Pay"
  },
  {
    "value": "Pier 1 Imports",
    "label": "Pier 1 Imports"
  },
  {
    "value": "Piggy Wiggly",
    "label": "Piggy Wiggly"
  },
  {
    "value": "Pilot Travel Centers",
    "label": "Pilot Travel Centers"
  },
  {
    "value": "Plaid Pantry",
    "label": "Plaid Pantry"
  },
  {
    "value": "Planet Beauty",
    "label": "Planet Beauty"
  },
  {
    "value": "Planet Organic",
    "label": "Planet Organic"
  },
  {
    "value": "Play It Again",
    "label": "Play It Again"
  },
  {
    "value": "Price Chopper ",
    "label": "Price Chopper "
  },
  {
    "value": "PriceRite",
    "label": "PriceRite"
  },
  {
    "value": "Proxim",
    "label": "Proxim"
  },
  {
    "value": "Public",
    "label": "Public"
  },
  {
    "value": "Publix",
    "label": "Publix"
  },
  {
    "value": "Quality Food Centers",
    "label": "Quality Food Centers"
  },
  {
    "value": "QuickChek",
    "label": "QuickChek"
  },
  {
    "value": "QuikTrip",
    "label": "QuikTrip"
  },
  {
    "value": "QVC",
    "label": "QVC"
  },
  {
    "value": "QVC ",
    "label": "QVC "
  },
  {
    "value": "QVC UK",
    "label": "QVC UK"
  },
  {
    "value": "RaceTrac Petroleum",
    "label": "RaceTrac Petroleum"
  },
  {
    "value": "Rainbow Shops",
    "label": "Rainbow Shops"
  },
  {
    "value": "Raley's",
    "label": "Raley's"
  },
  {
    "value": "Ralphs",
    "label": "Ralphs"
  },
  {
    "value": "Reasors ",
    "label": "Reasors "
  },
  {
    "value": "Reasor's Foods ",
    "label": "Reasor's Foods "
  },
  {
    "value": "Red Apple",
    "label": "Red Apple"
  },
  {
    "value": "Redner's Market",
    "label": "Redner's Market"
  },
  {
    "value": "REI",
    "label": "REI"
  },
  {
    "value": "Renys",
    "label": "Renys"
  },
  {
    "value": "Rexall",
    "label": "Rexall"
  },
  {
    "value": "Riley Rose",
    "label": "Riley Rose"
  },
  {
    "value": "Rite Aid",
    "label": "Rite Aid"
  },
  {
    "value": "Ritz Carlton",
    "label": "Ritz Carlton"
  },
  {
    "value": "Roche Bros",
    "label": "Roche Bros"
  },
  {
    "value": "Roche Bros. Supermarkets",
    "label": "Roche Bros. Supermarkets"
  },
  {
    "value": "Rocket Fizz",
    "label": "Rocket Fizz"
  },
  {
    "value": "Rogers Wireless",
    "label": "Rogers Wireless"
  },
  {
    "value": "Ross Stores",
    "label": "Ross Stores"
  },
  {
    "value": "Roundy’s",
    "label": "Roundy’s"
  },
  {
    "value": "Roundy's Supermarkets",
    "label": "Roundy's Supermarkets"
  },
  {
    "value": "Rouses",
    "label": "Rouses"
  },
  {
    "value": "Rouse's",
    "label": "Rouse's"
  },
  {
    "value": "Rural King ",
    "label": "Rural King "
  },
  {
    "value": "Safeway",
    "label": "Safeway"
  },
  {
    "value": "Sainsbury's",
    "label": "Sainsbury's"
  },
  {
    "value": "Saks",
    "label": "Saks"
  },
  {
    "value": "Sally Beauty",
    "label": "Sally Beauty"
  },
  {
    "value": "Sam's Club",
    "label": "Sam's Club"
  },
  {
    "value": "SamsClub.com",
    "label": "SamsClub.com"
  },
  {
    "value": "Save Mart",
    "label": "Save Mart"
  },
  {
    "value": "Save-On-Foods",
    "label": "Save-On-Foods"
  },
  {
    "value": "Savi Provisions ",
    "label": "Savi Provisions "
  },
  {
    "value": "Schnucks",
    "label": "Schnucks"
  },
  {
    "value": "Seafood City",
    "label": "Seafood City"
  },
  {
    "value": "Sears",
    "label": "Sears"
  },
  {
    "value": "Sears.com",
    "label": "Sears.com"
  },
  {
    "value": "Sedano’s",
    "label": "Sedano’s"
  },
  {
    "value": "Selfridges",
    "label": "Selfridges"
  },
  {
    "value": "Sephora",
    "label": "Sephora"
  },
  {
    "value": "SFR",
    "label": "SFR"
  },
  {
    "value": "Sharper Image",
    "label": "Sharper Image"
  },
  {
    "value": "Shaws",
    "label": "Shaws"
  },
  {
    "value": "Shell",
    "label": "Shell"
  },
  {
    "value": "ShopLadder.com",
    "label": "ShopLadder.com"
  },
  {
    "value": "Shop 'n Save",
    "label": "Shop 'n Save"
  },
  {
    "value": "SHOP'n SAVE",
    "label": "SHOP'n SAVE"
  },
  {
    "value": "Shoppers Drug Mart",
    "label": "Shoppers Drug Mart"
  },
  {
    "value": "Shoppers World",
    "label": "Shoppers World"
  },
  {
    "value": "ShopRite",
    "label": "ShopRite"
  },
  {
    "value": "Sleek Hair",
    "label": "Sleek Hair"
  },
  {
    "value": "SleekShop.com",
    "label": "SleekShop.com"
  },
  {
    "value": "Smart & Final",
    "label": "Smart & Final"
  },
  {
    "value": "Smith's",
    "label": "Smith's"
  },
  {
    "value": "Snacknation",
    "label": "Snacknation"
  },
  {
    "value": "Snuggle Bugz",
    "label": "Snuggle Bugz"
  },
  {
    "value": "Sobeys",
    "label": "Sobeys"
  },
  {
    "value": "Softbank",
    "label": "Softbank"
  },
  {
    "value": "Soko Glam ",
    "label": "Soko Glam "
  },
  {
    "value": "Space NK",
    "label": "Space NK"
  },
  {
    "value": "Spar",
    "label": "Spar"
  },
  {
    "value": "Spartan",
    "label": "Spartan"
  },
  {
    "value": "Spec's",
    "label": "Spec's"
  },
  {
    "value": "Speedway",
    "label": "Speedway"
  },
  {
    "value": "Spencer's",
    "label": "Spencer's"
  },
  {
    "value": "Sports Authority",
    "label": "Sports Authority"
  },
  {
    "value": "Sportsman's Warehouse",
    "label": "Sportsman's Warehouse"
  },
  {
    "value": "Spring Market",
    "label": "Spring Market"
  },
  {
    "value": "Sprouts Farmers Market",
    "label": "Sprouts Farmers Market"
  },
  {
    "value": "Staples",
    "label": "Staples"
  },
  {
    "value": "Staples.com",
    "label": "Staples.com"
  },
  {
    "value": "Stater Bros.",
    "label": "Stater Bros."
  },
  {
    "value": "Stine ",
    "label": "Stine "
  },
  {
    "value": "Stop-n-Shop",
    "label": "Stop-n-Shop"
  },
  {
    "value": "Strack & Van Til ",
    "label": "Strack & Van Til "
  },
  {
    "value": "Sunset Foods",
    "label": "Sunset Foods"
  },
  {
    "value": "Super 1 Foods ",
    "label": "Super 1 Foods "
  },
  {
    "value": "Superior Grocers ",
    "label": "Superior Grocers "
  },
  {
    "value": "Super King",
    "label": "Super King"
  },
  {
    "value": "SUPERVALU",
    "label": "SUPERVALU"
  },
  {
    "value": "Supplement Giant",
    "label": "Supplement Giant"
  },
  {
    "value": "Sur La Table",
    "label": "Sur La Table"
  },
  {
    "value": "Target",
    "label": "Target"
  },
  {
    "value": "Target AU",
    "label": "Target AU"
  },
  {
    "value": "Target.com",
    "label": "Target.com"
  },
  {
    "value": "Teknikmagasinet",
    "label": "Teknikmagasinet"
  },
  {
    "value": "Terrible Herbst",
    "label": "Terrible Herbst"
  },
  {
    "value": "Tesco",
    "label": "Tesco"
  },
  {
    "value": "The Chopra Center",
    "label": "The Chopra Center"
  },
  {
    "value": "The Container Store",
    "label": "The Container Store"
  },
  {
    "value": "The Finish Line",
    "label": "The Finish Line"
  },
  {
    "value": "The Fresh Market",
    "label": "The Fresh Market"
  },
  {
    "value": "TheGrommet",
    "label": "TheGrommet"
  },
  {
    "value": "The Grommet",
    "label": "The Grommet"
  },
  {
    "value": "The Happy Herb Company",
    "label": "The Happy Herb Company"
  },
  {
    "value": "The Home Depot",
    "label": "The Home Depot"
  },
  {
    "value": "The Hut Group",
    "label": "The Hut Group"
  },
  {
    "value": "The Makeup Club",
    "label": "The Makeup Club"
  },
  {
    "value": "The Wish Bone Pet Co",
    "label": "The Wish Bone Pet Co"
  },
  {
    "value": "ThinkGeek",
    "label": "ThinkGeek"
  },
  {
    "value": "ThriveMarket",
    "label": "ThriveMarket"
  },
  {
    "value": "Tillys",
    "label": "Tillys"
  },
  {
    "value": "Times Supermarkets",
    "label": "Times Supermarkets"
  },
  {
    "value": "TJ Maxx",
    "label": "TJ Maxx"
  },
  {
    "value": "TJX Canada",
    "label": "TJX Canada"
  },
  {
    "value": "Tony's Fresh Market",
    "label": "Tony's Fresh Market"
  },
  {
    "value": "Tops Friendly Markets",
    "label": "Tops Friendly Markets"
  },
  {
    "value": "Topshop",
    "label": "Topshop"
  },
  {
    "value": "Tops Markets",
    "label": "Tops Markets"
  },
  {
    "value": "Total Wine ",
    "label": "Total Wine "
  },
  {
    "value": "Toys 'R' Us",
    "label": "Toys 'R' Us"
  },
  {
    "value": "Tractor Supply Company",
    "label": "Tractor Supply Company"
  },
  {
    "value": "Trader Joe's",
    "label": "Trader Joe's"
  },
  {
    "value": "Tresierras Supermarkets",
    "label": "Tresierras Supermarkets"
  },
  {
    "value": "True Value",
    "label": "True Value"
  },
  {
    "value": "Tuesday Morning",
    "label": "Tuesday Morning"
  },
  {
    "value": "TVSN",
    "label": "TVSN"
  },
  {
    "value": "Twin Liquors",
    "label": "Twin Liquors"
  },
  {
    "value": "ULTA",
    "label": "ULTA"
  },
  {
    "value": "Ulta.com",
    "label": "Ulta.com"
  },
  {
    "value": "Uncommon Goods ",
    "label": "Uncommon Goods "
  },
  {
    "value": "Uniprix",
    "label": "Uniprix"
  },
  {
    "value": "United Airlines",
    "label": "United Airlines"
  },
  {
    "value": "United Supermarkets",
    "label": "United Supermarkets"
  },
  {
    "value": "Urban Fare",
    "label": "Urban Fare"
  },
  {
    "value": "Urban Outfitters",
    "label": "Urban Outfitters"
  },
  {
    "value": "Value Drugs",
    "label": "Value Drugs"
  },
  {
    "value": "Valu King",
    "label": "Valu King"
  },
  {
    "value": "Verizon Wireless",
    "label": "Verizon Wireless"
  },
  {
    "value": "Vita-Cost",
    "label": "Vita-Cost"
  },
  {
    "value": "Vitacost.com",
    "label": "Vitacost.com"
  },
  {
    "value": "Vitamin Cottage",
    "label": "Vitamin Cottage"
  },
  {
    "value": "Vitamin Shoppe",
    "label": "Vitamin Shoppe"
  },
  {
    "value": "Vitamin World",
    "label": "Vitamin World"
  },
  {
    "value": "Vita Natura",
    "label": "Vita Natura"
  },
  {
    "value": "Von Maur",
    "label": "Von Maur"
  },
  {
    "value": "Waitrose",
    "label": "Waitrose"
  },
  {
    "value": "Wakefern/ShopRite",
    "label": "Wakefern/ShopRite"
  },
  {
    "value": "Walgreens",
    "label": "Walgreens"
  },
  {
    "value": "Walgreens.com",
    "label": "Walgreens.com"
  },
  {
    "value": "Walmart",
    "label": "Walmart"
  },
  {
    "value": "Walmart Canada",
    "label": "Walmart Canada"
  },
  {
    "value": "Walmart.com",
    "label": "Walmart.com"
  },
  {
    "value": "Wawa",
    "label": "Wawa"
  },
  {
    "value": "Wayfair.com",
    "label": "Wayfair.com"
  },
  {
    "value": "WB Liquors",
    "label": "WB Liquors"
  },
  {
    "value": "Wegman's",
    "label": "Wegman's"
  },
  {
    "value": "Weis Markets",
    "label": "Weis Markets"
  },
  {
    "value": "Well.Ca",
    "label": "Well.Ca"
  },
  {
    "value": "West Coast Beauty",
    "label": "West Coast Beauty"
  },
  {
    "value": "West Elm",
    "label": "West Elm"
  },
  {
    "value": "Westerly Natural Market",
    "label": "Westerly Natural Market"
  },
  {
    "value": "Western Beef Supermarket",
    "label": "Western Beef Supermarket"
  },
  {
    "value": "Westin Hotels & Resorts",
    "label": "Westin Hotels & Resorts"
  },
  {
    "value": "Westside Market",
    "label": "Westside Market"
  },
  {
    "value": "Whole Foods Market",
    "label": "Whole Foods Market"
  },
  {
    "value": "W Hotels ",
    "label": "W Hotels "
  },
  {
    "value": "WHSmith",
    "label": "WHSmith"
  },
  {
    "value": "Wigs.com",
    "label": "Wigs.com"
  },
  {
    "value": "Wild Bill's Tabacco",
    "label": "Wild Bill's Tabacco"
  },
  {
    "value": "Williams-Sonoma",
    "label": "Williams-Sonoma"
  },
  {
    "value": "WinCo Foods",
    "label": "WinCo Foods"
  },
  {
    "value": "Winn-Dixie",
    "label": "Winn-Dixie"
  },
  {
    "value": "Winners",
    "label": "Winners"
  },
  {
    "value": "Woodhouse Spas",
    "label": "Woodhouse Spas"
  },
  {
    "value": "Woodman's",
    "label": "Woodman's"
  },
  {
    "value": "Yoke's Fresh Market",
    "label": "Yoke's Fresh Market"
  },
  {
    "value": "Younkers",
    "label": "Younkers"
  },
  {
    "value": "Zerbo's",
    "label": "Zerbo's"
  },
  {
    "value": "Zulily.com",
    "label": "Zulily.com"
  },
  {
    "value": "Zupan's",
    "label": "Zupan's"
  }
]